import { Paths } from "@/core/constants/paths";
import type { PageHeaderTabItem } from "@/ds";

export const RECURSOS_TITLE = "Recursos";

export const RECURSOS_TABS_LABEL = "Abas de Recursos";

/** Mobile (Figma Mobile/Profissionais): as abas viram um seletor ao lado do título. */
export const RECURSOS_MOBILE_QUERY = "(max-width: 768px)";

/**
 * Abas do módulo Recursos. O acesso é decidido pela API (privilégio
 * `hub.equipe:visualizar`), então todas ficam visíveis e cada aba trata o 403.
 */
export const RECURSOS_TABS: readonly PageHeaderTabItem[] = [
  { label: "Profissionais", to: Paths.RECURSOS_PROFISSIONAIS },
  { label: "Carga de Trabalho", to: Paths.RECURSOS_CARGA_DE_TRABALHO },
];
